/**
 * Adobe analytics functions
 */

/**
 * Initialise Adobe
 */
export function initialise (params) {
	// Derive settings based on host
	const { host } = location;
	let settings: any = params.find((_: any) => _.domain === host);
	if (!settings) {
		settings = params.find((_: any) => _.domain === '*');
	}

	const existingScript = document.querySelector('[name="adobe-analytics-script"]');
	if (existingScript) { return; }

	// Adding adobe script
	if (settings && settings.script) {
		const script: HTMLScriptElement = document.createElement('script');
		script.setAttribute('src', settings.script);
		script.setAttribute('async', '');
		script.setAttribute('name', 'adobe-analytics-script');
		
		script.onload = () => {
			console.log(`[Analytics] Script added ${settings.script}`);
		};

		document.head.appendChild(script);
	}
}

/**
 * Tracking route function
 */
export function trackRoute (route: any, sessionID: string) {
	const { name, path } = route;
	const type = 'page-visited';
	const timestamp = Date.now();

	// Adobe variables
	const pageName = name;
	const pageURL = path;
	const pageType = type;
	const language = 'en';
	const brand = 'COVID-19 Medical Hub';
	const platform = location.host;
	const referringURL = null;
	const currencyCode = null;
	const primaryMessageCategory = null;
	const pageSource  = null;
	const contentOrigin = null;
	const gcma = null;
	const trackingCode = null;
	const siteName = null;
	const country = null;
	const pageGcma = null;
	const indication = null;
	const therapeuticArea = null;

	try {
		// TODO: Test with the Pfizer team and remove the top s.pfLinkName in case of duplicity
		s.pfPage(
			pageName,
			pageURL,
			pageType,
			referringURL,
			language,
			currencyCode,
			primaryMessageCategory,
			pageSource,
			contentOrigin,
			brand,
			gcma,
			trackingCode,
			platform,
			sessionID,
			siteName,
			country,
			pageGcma,
			indication,
			therapeuticArea
		);
		s.pfPageLoad();
		s.pfLinkName(
			'page-visited',
			'internal',
		);

		console.info(`[Adobe Analytics Tracking]: ${timestamp}:: ${type} | Route path: ${path}`);
	} catch (err) {
		console.log('[Adobe Analytics Error]: ', err);
	}
}

/**
 * Tracking click function
 */
export function trackClick (trackingObj: any) {
	const { name, id } = trackingObj;

	s.pfLinkName(
		`click|${name}|${id}`,
		'internal',
	);

	console.info(`[Adobe Analytics Clicks]: ${name}|${id}|click`);
}